export { default, getStaticProps } from '.';
import { getStaticPaths as luciferGetStaticPaths } from '@lcifr/pages/getStatic';
import { GetStaticPathsContext } from 'next';

export async function getStaticPaths(ctx: GetStaticPathsContext) {
  const getStaticPathsResult = await luciferGetStaticPaths(ctx);
  getStaticPathsResult.paths = getStaticPathsResult.paths.filter((path) => {
    if (typeof path !== 'string' && path.locale === 'en') {
      return true;
    } else {
      return false;
    }
  });
  return getStaticPathsResult;
}
